import { render, staticRenderFns } from "./Pin.vue?vue&type=template&id=b971a224&scoped=true&"
import script from "./Pin.vue?vue&type=script&lang=js&"
export * from "./Pin.vue?vue&type=script&lang=js&"
import style0 from "./Pin.vue?vue&type=style&index=0&id=b971a224&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b971a224",
  null
  
)

export default component.exports